export default {
  title: {
    en: 'Would you like to add a monthly fragrance subscription?',
  },
  course: {
    title: {
      en: `
        <span class="text-gold-50">Save on this course</span> with a <br /> Scentbird subscription.
      `,
    },
  },
  text: {
    en: `
      A month-to-month subscription to Scentbird. Billed monthly,
      renews automatically.
    `,
  },
  emptyProduct: {
    en: `
      Your choice of one 8ml fragrance a month, with a free case included
    `,
  },
  no: {
    en: 'No thanks',
  },
  yes: {
    en: 'Yes, add it!',
  },
}
